import { theme } from '@moonpig/launchpad-theme'
import React, { FC, ReactNode } from 'react'

interface AttachLayoutProps {
  children: ReactNode
}

export const AttachLayout: FC<AttachLayoutProps> = ({ children }) => {
  return (
    <>
      <style>
        {`
          body {
            background-color: ${theme.colors.colorBlack00};
          }
        `}
      </style>
      {children}
    </>
  )
}
